import { useMemo } from 'react'
import { thirdwebClient } from '.'
import { useProfiles } from 'thirdweb/react'
import { createAvatar, BackgroundType } from '@dicebear/core'
import { identicon } from '@dicebear/collection'

export interface Profile {
  email?: string
  nickname?: string
  avatar?: string
}
export const useProfile = (): {
  data: Profile
  isFetching: boolean
} => {
  const { data, isFetching } = useProfiles({
    client: thirdwebClient,
  })
  const email = data?.find(item => item.details.email)?.details.email
  const nickname = email?.slice?.(0, email?.indexOf?.('@'))
  const avatar = useMemo(() => {
    return email
      ? createAvatar(identicon, {
          size: 64,
          scale: 50,
          seed: email,
          backgroundColor: ['b6e3f4', 'c0aede'],
          backgroundType: ['gradientLinear'],
          // ... other options
        }).toDataUri()
      : ''
  }, [email])

  return {
    data: {
      email,
      nickname,
      avatar,
    },
    isFetching,
  }
}
